import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { CargueArchivoControlPagosComponent } from './CargueArchivoControlPagos.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'CargueArchivoControlPagos',
        component: CargueArchivoControlPagosComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CargueArchivoControlPagos',
          nombreFormulario : 'Cargue Archivo Control Pagos'
        } 
    }
];


@NgModule({
    declarations: [
        CargueArchivoControlPagosComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        CargueArchivoControlPagosComponent
    ],
    bootstrap: [CargueArchivoControlPagosComponent]
})

export class CargueArchivoControlPagosModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CargueArchivoControlPagos/CargueArchivoControlPagos.module.ts